<script>
  import { onMount, onDestroy, tick, getContext } from 'svelte'
  import { writable } from 'svelte/store'
  import { slide } from 'svelte/transition'
  import { fly } from 'svelte/transition'
  import { settings, createWritableStore } from '../src/data_storage.js'
  settings.useLocalStorage()
  import { _, locale, locales } from 'svelte-i18n'
  import { formatCurrency } from '../src/utils'
  import { Link } from "../rout"

  export let kiches
  export let choose_handler
  export let scroll
  const { getScrollY } = getContext('app')

  const yScroll = createWritableStore('yScroll', 0)
  yScroll.useLocalStorage()

  function mountFromData(data, pushState = false) {
    // console.log(data)
  }

  function loadSettings() {
  }

  function saveSettings() {
  }

  onDestroy(() => {
    $yScroll = getScrollY()
    // console.log('destroyed kichlist ' + $yScroll + '  ' + window.scrollY)
  })

  onMount(async () => {
    // console.log('kich_list onMount')
    mountFromData(kiches)
    loadSettings()
  })

  // not used
  function choose(kich) {
    // console.log('choose ' + kich.title)
    if (choose_handler) {
      choose_handler(kich)
    }
  }
</script>

<div class="m-1 grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
  {#if kiches}
    {#each kiches as kich, index}
      <Link to="{kich.slug}" on:click={()=> choose(kich)}>
        {#if (kich.azzets[0])}
          <div class="kich flex flex-row justify-center">
            <div class="grow relative">
              {#if kich.sold}
                <span class="absolute top-1 right-1 text-md rounded p-1 bg-red-600 text-white font-bold flex justify-center">
                {kich.kind === 'tangible' ? $_('sold') : $_('reserved')}
                </span>
              {/if}
              <img class="rounded" src={kich.azzets[0].azzet_url} alt={kich.azzets[0].title}/>
              <span class="text-md">{kich.title}</span>
              <span class="text-md text-gray-500" class:line-through={kich.sold && kich.kind === 'tangible'}>{formatCurrency(kich.price, $settings.locale, $settings.currency, 2, 0)}</span>
            </div>
          </div>
        {:else}
          <div class="kich flex flex-row justify-center border rounded">
            <div class="grow h-40 p-1 relative">
              <span class="text-md">{kich.title}</span>
              <span class="text-md text-gray-500" class:line-through={kich.sold && kich.kind === 'tangible'}>{formatCurrency(kich.price, $settings.locale, $settings.currency, 2, 0)}</span>
              {#if kich.sold}
                <span class="absolute inset-y-16 inset-x-12 text-md rounded p-1 bg-red-600 text-white font-bold flex justify-center">{$_('sold')}</span>
              {/if}
            </div>
          </div>
        {/if}
      </Link>
    {/each}
  {/if}
</div>
